var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box, Text } from 'pcln-design-system';
var Wrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    flex: 1;\n  }\n"], ["\n  ", " {\n    flex: 1;\n  }\n"])), themeGet('mediaQueries.lg'));
var StyledText = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n\n  ", " {\n    text-align: left;\n  }\n"], ["\n  text-align: center;\n\n  ", " {\n    text-align: left;\n  }\n"
    /** @public */
])), themeGet('mediaQueries.lg'));
/**
 * The OptInText class
 * @public
 */
var OptInText = function (_a) {
    var headline = _a.headline, subheadline = _a.subheadline, _b = _a.spaceBetweenHeadlines, spaceBetweenHeadlines = _b === void 0 ? 0 : _b, _c = _a.subheadlineFontSize, subheadlineFontSize = _c === void 0 ? 1 : _c;
    return (React.createElement(Wrapper, { alignItems: 'center', justifyContent: 'center', p: 1 },
        React.createElement(StyledText, { color: 'text', fontWeight: 'bold', fontSize: 3, m: 0, mb: spaceBetweenHeadlines }, headline),
        React.createElement(StyledText, { color: 'text.light', fontSize: subheadlineFontSize, m: 0 }, subheadline)));
};
export default OptInText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=OptInText.js.map